import { FONT } from "../../../value/staticValues";
import { numberOfCommas, parseLocaleDatetime } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";


import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { DropdownType } from "../../base/CustomDropdown";
import { ListActionMenu, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import LicenseUpdate from "./LicenseUpdate";


export interface ProductData {
    product_id: string;
    product_name: string;
    product_description: string;
    product_type_code: string;
}


export interface ProductOptionData {
    product_option_id: string;
    product_option_name: string;
    product_option_description: string;
    product_option_type_code: string;
    product_option_target_code: string;
}

export interface PurchaseData {
    purcahse_id: string;
    purchase_number: string;
    purchase_ts: string;
    payment_name: string;
    payment_method_code: string;
    total_payment_amount: string;
    receipt_link_url: string;
    purchase_source: string;
    create_ts: string;
    update_ts: string;
}

export interface RdsClientDevice {
    rds_client_device_id: string;
    device_name: string;
    device_os_name: string;
    device_serial_number: string;
    processor_spec: string;
    memory_spec: string;
    graphic_spec: string;
    physical_spec: string;
    client_version: string;
    license_activate_yn: boolean;
    last_login_ts: string;
    last_session_ts: string;
    current_login_ts: string;
    activate_ts: string;
    deactivate_ts: string;
    verify_ts: string;
    public_ip_address: string;
    private_ip_addresses: string;
}

export interface LicenseData {
    license_id: string;
    license_name: string;
    license_number: string;
    email: string;
    purchase_ts: string;

    product: ProductData;
    product_options: ProductOptionData[];
    purchases: PurchaseData[];
    create_ts: string;
    update_ts: string;

    device_count: number;
    multi_user_count: number;
    multi_monitor_count: number;
    upgrade_support_years: number;
    upgrade_support_expire_ts: string;
    use_expire_dates: number;
    relay_session_count: number;
    license_expire_ts: string;
    purchase_source: string;
    devices: RdsClientDevice[];
}


export const initLicenseData = {
    license_id: "",
    license_name: "",
    license_number: "",
    email: "",
    purchase_ts: "",

    product: {
        product_id: "",
        product_name: "",
        product_description: "",
        product_type_code: ""
    },
    product_options: [],
    purchases: [],
    create_ts: "",
    update_ts: "",

    device_count: 0,
    multi_user_count: 0,
    multi_monitor_count: 0,
    upgrade_support_years: 0,
    upgrade_support_expire_ts: "",
    use_expire_dates: 0,
    license_expire_ts: "",
    purchase_source: "",
    devices: []
}

export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "LICENSE_DELETE",
        },
    }
]
export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("SERVICE_LICENSE_NUMBER_TEXT"),
        accessor: "license_number",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_PRODUCT_TYPE_TEXT"),
        accessor: "product.product_type_code",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 50, height: 20,
                paddingLeft: 10, paddingRight: 10,
                borderRadius: 10,
                backgroundColor: value === "RDS" ? "#66abe8" : value === "VDI" ? "#92ca6e" : "#b6bfce",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: "#fff"
            }}>
                {
                    value === "RDS" ? "RDS"
                    : value === "VDI" ? "VDI"
                    : "None"
                }
            </div>
        )
    },
    {
        Header: i18n.t("SERVICE_LICENSE_NAME_TEXT"),
        accessor: "license_name",
        disableSortBy: false,
        style: {
            width: "140px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("ACCOUNT_TEXT"),
        accessor: "email",
        disableSortBy: false,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_LICENSE_UPGRADE_EXPIRE_YN_TEXT"),
        accessor: "upgrade_support_expire_ts",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    new Date(value) > new Date() ? <><StatusStableImg style={className.statusImg}/>Usable</> : <><StatusBlockImg style={className.statusImg}/>Expire</>
                }
            </div>
        )
    },
    {
        Header: i18n.t("SERVICE_LICENSE_EXPIRE_DATE_TEXT"),
        accessor: "license_expire_ts",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    !value ? <><StatusStableImg style={className.statusImg}/>Usable</>
                    : new Date(value) > new Date() ? <><StatusStableImg style={className.statusImg}/>Usable</> : <><StatusBlockImg style={className.statusImg}/>Expire</> 
                }
            </div>
        )
    },
    {
        Header: i18n.t("SERVICE_PURCHASE_SOURCE_TEXT"),
        accessor: "purchase_source",
        disableSortBy: false,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? value : "FornaX Cloud Official Site"}</div>)
    },
    {
        Header: i18n.t("SERVICE_PURCHASE_DATE_TEXT"),
        accessor: "purchase_ts",
        disableSortBy: false,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
]


export const licenseUpdateModalContent = {
    title: i18n.t("SERVICE_LICENSE_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <LicenseUpdate />,
}


const className = {
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    greenText: {
        color: "#3a8344"
    }
}